<template>
    <div class="spinner">
        <div class="wrapper" :class="wrapperClasses">
            <div class="slice one" :style="firstStyle"></div>
            <div class="slice two" :style="secondStyle"></div>
            <div class="chart-center">
                <countdown class="countdown" :seconds-left="secondsLeft" :label="label"></countdown>
            </div>
        </div>
    </div>
</template>

<script>
import Countdown from '@tv/components/partials/Countdown';

export default {
    props: ['progress', 'secondsLeft', 'label'],

    components: { Countdown },

    computed: {
        degrees() {
            return 360 * this.progress;
        },

        wrapperClasses() {
            if (this.progress >= 0.5) {
                return ['halfway'];
            }

            return [];
        },

        firstStyle() {
            let degrees = 90;

            if (this.progress < 0.5) {
                degrees = this.degrees + 90;
            }

            return { 'transform': `rotate(${degrees}deg)` };
        },

        secondStyle() {
            let degrees = this.degrees;

            if (this.progress < 0.5) {
                degrees = 0;
            }

            return { 'transform': `rotate(${degrees}deg)` };
        },
    },
}
</script>